import { FC, useState } from 'react';
import ApiServiceContext from './context';
import {IApiService} from '../../api/IApiService';
import {mockApiService} from '../../api/MockApiService';
import {useSettingsContext} from '../settings/useSettingsContext';
import {createApiService} from '../../api/ApiService';

type Props = {
    useMock?: boolean,
    children?: React.ReactNode;
}

const ApiServiceContextProvider: FC<Props> = (
    {
        useMock = false,
        children
    }
) => {
    const settings = useSettingsContext();
    const apiService: IApiService = useMock
        ? mockApiService
        : createApiService(
            settings.tokenUrl,
            settings.apiUrl,
            settings.debugMode,
            settings.useGoogleRecaptchaV3,
            settings.recaptchaUrl,
            settings.companyInfoId,
        )
    ;

    const [companyInfoId, setCompanyInfoId] = useState('');

    return (
        <ApiServiceContext.Provider value={{ apiService, companyInfoId, setCompanyInfoId }}>
            {children}
        </ApiServiceContext.Provider>
    );
};

export default ApiServiceContextProvider;
